// One position with live prices: shared by the portfolio list and the instrument screen's «У вас» block
// (docs/live-prices/SPEC.md, decision 10; docs/instrument/SPEC.md, decision 2).
import { toNumber } from './format';

// uid → { price, time } from GET /portfolios/live-prices
export function livePriceOf(position, livePrices) {
  return livePrices[position.instrument_uid] ?? null;
}

// Live price when the daemon has one, otherwise the snapshot price.
export function currentPriceOf(position, livePrices) {
  return toNumber(livePriceOf(position, livePrices)?.price) ?? toNumber(position.current_price);
}

// Price move since the snapshot, for the whole position. 0 without a live price.
function liveDelta(position, livePrices) {
  const live = toNumber(livePriceOf(position, livePrices)?.price);
  const snapshot = toNumber(position.current_price);
  const qty = toNumber(position.quantity);
  if (live === null || snapshot === null || qty === null) {
    return 0;
  }
  return (live - snapshot) * qty;
}

// Broker's yield from the snapshot plus the move since then, so its rules (fees, FIFO, etc.) are kept.
export function yieldAbsOf(position, livePrices) {
  const snapshot = toNumber(position.expected_yield);
  return snapshot === null ? null : snapshot + liveDelta(position, livePrices);
}

export function yieldPercentOf(position, livePrices) {
  const avg = toNumber(position.average_price);
  const qty = toNumber(position.quantity);
  const value = yieldAbsOf(position, livePrices);
  if (!avg || !qty || value === null) {
    return null;
  }
  return (value / Math.abs(avg * qty)) * 100;
}

export function marketValueOf(position, livePrices) {
  const price = currentPriceOf(position, livePrices);
  const qty = toNumber(position.quantity);
  return price === null || qty === null ? null : price * qty;
}

// Today's change of one position: the broker's daily_yield in the snapshot plus the move since it
// (docs/portfolios/SPEC.md, decision 26). The caller checks that the snapshot is from today.
export function dailyYieldOf(position, livePrices) {
  const snapshot = toNumber(position.daily_yield);
  return snapshot === null ? null : snapshot + liveDelta(position, livePrices);
}

// % of yesterday's value (today's value minus today's change).
export function dailyPercentOf(position, livePrices) {
  const daily = dailyYieldOf(position, livePrices);
  const value = marketValueOf(position, livePrices);
  if (daily === null || value === null || value - daily === 0) {
    return null;
  }
  return (daily / Math.abs(value - daily)) * 100;
}
